import { BrickContext } from 'olympe';
import { TimeoutMap } from '@olympeio/core';
import { format, parse, add } from 'date-fns';

export const refactorPriceRange = (priceRange) => {
    let range = priceRange;
    range = range.replace('=<', '<=').replace('=>', '>=');
    let tmp = range.match(/ ?>?=? ?(\d*)/);
    const min = tmp && tmp[1] !== '' ? tmp[1] : '0';
    tmp = range.match(/ ?<=? ?(\d*)/);
    const max = tmp ? tmp[1] : min;
    if (min !== max) {
        return `${min.toLocaleString()} - ${max.toLocaleString()}`;
    } else {
        return `${min.toLocaleString()} & higher`;
    }
};

export const mapIterator = (map, cb) => {
    const agg = [];
    for (const [key, value] of map) {
        agg.push(cb(value, key));
    }
    return agg;
};

const getCurrentMinMax = (priceRange) => {
    let range = priceRange || '> 0';
    range = range.replace('=<', '<=').replace('=>', '>=');
    let tmp = range.match(/ ?>?=? ?(\d*)/);
    const min = tmp && tmp[1] !== '' ? tmp[1] : '0';
    tmp = range.match(/ ?<=? ?(\d*)/);
    const max = tmp ? tmp[1] : min;
    return { min: Number.parseInt(min, 10), max: Number.parseInt(max, 10) };
};

export const getBand = (priceRange) => {
    const { min, max } = getCurrentMinMax(priceRange);
    if (min !== max) return `${min.toLocaleString()} - ${max.toLocaleString()}`;
    else return `${min.toLocaleString()} & higher`;
};

/**
 * Parse error message returned by IdSet endpoint
 * TODO should apply this on the XMLs returned by MassChange multipart call
 * TODO add support of login error when using an invalid user ID (errorMessage is in text/html)
 * @param {string} jsonString
 * @returns {{sapErrorCode: *, sapErrorMessage: *}}
 */
export const parseChangeErrorResponse = (jsonString) => {
    let json;
    try {
        json = JSON.parse(jsonString);
    } catch (e) {
        /* empty */
    }

    let sapErrorMessage, sapErrorCode;
    if (json !== undefined) {
        // standard error code and message
        try {
            sapErrorCode = json.error.code;
        } catch (e) {
            /* empty */
        }
        try {
            sapErrorMessage = json.error.message;
            if (typeof sapErrorMessage === 'object') {
                sapErrorMessage = sapErrorMessage.value;
            }
        } catch (e) {
            /* empty */
        }

        // detailed error for missing role and approver already exists error
        try {
            sapErrorMessage = json.error.innererror.errordetails[0].message;
            sapErrorCode = json.error.innererror.errordetails[0].code;
        } catch (e) {
            /* empty */
        }
    }

    return {
        sapErrorMessage,
        sapErrorCode,
    };
};

/**
 * Returns the root context of the given context.
 * @param {BrickContext} $
 * @returns {BrickContext}
 */
export const getRootContext = ($) => {
    const contexts = /** @type {BrickContext[]} */ ([$]);
    for (const current of contexts) {
        const parent = current.getParent();
        parent && contexts.push(parent);
    }
    return contexts.pop();
};

const ROOT_CACHE_NAME = 'AXIOS_GET_CACHE';

/**
 * Get timeout map from root context
 * @param {BrickContext} $
 * @returns {TimeoutMap}
 */
export const getRootTimeoutMap = ($) => {
    const rootContext = getRootContext($);
    if (!rootContext.has(ROOT_CACHE_NAME)) {
        // 4h and 30 minutes
        rootContext.set(ROOT_CACHE_NAME, new TimeoutMap(14400000, 1800000));
    }
    return rootContext.get(ROOT_CACHE_NAME);
};

export const formatApiDate = (value) => {
    if (typeof value === 'string' && value.startsWith('/Date(')) {
        const offset = new Date().getTimezoneOffset();
        const timestamp = value.replace('/Date(', '').replace(')/', '');
        const date = parse(`${timestamp}`, 'T', new Date());
        return format(add(date, { minutes: offset }), 'dd/MM/yyyy');
    } else if (typeof value === 'string' && value.includes('-')) {
        return value.substring(0, 10);
    }
};
